<template>
    <div ref="dropdown" :class="['custom-select-container', theme, { 'is-disabled-local': disabled }]">
        <label :class="['custom_label', { 'label_margin': label != '' }]">{{ label }}</label>
        <div class="custom-dropdown" @click="toggleDropdown">
            <!-- Etiqueta principal -->
            <div class="dropdown_label_select" v-bind:class="{ 'dropdown_label_select_clicked': isOpen }">
                <span class="selected-label is-capitalized">
                    {{ labelDate }}
                </span>
                <ArrowDown class="actual_button_arrow_down" />
            </div>

            <!-- Menú desplegable -->
            <transition name="slide">
                <div class="dropdown-menu-select" v-if="isOpen">
                    <div class="calendar-container">
                        <!-- Cabecera -->
                        <div class="calendar-header">
                            <button @click.stop="() => updateYear(-1)"
                                v-if="!disableOldDates || currentYear > initialDate.getFullYear()">
                                <ArrowDown class="actual_button_arrow_down rotateLeft" />
                            </button>

                            <span class="is-unselectable">{{ currentYear }}</span>
                            <button @click.stop="() => updateYear(1)">
                                <ArrowDown class="actual_button_arrow_down rotateRight" />
                            </button>

                        </div>

                        <!-- Matriz de Meses -->
                        <div class="calendar-grid">
                            <div v-for="(month, index) in months" :key="index" :class="['month-cell',
                                {
                                    'is-disabled-local': isMonthDisabled(index),
                                    'month-cell-activated': isMonthSelected(index)
                                }]" @click="selectMonth(index)">
                                {{ month }}
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

        </div>
    </div>
</template>

<script>
import ArrowDown from "@/components/svg/ArrowDown.vue";
import moment from "moment";
export default {
    name: "AnualCalendar",
    components: {
        ArrowDown,
    },
    props: {
        disableOldDates: {
            type: Boolean,
            default: false
        },
        disabledFrom: {
            type: Date,
            required: false
        },
        theme: {
            type: String,
            default: 'default_theme'
        },
        label: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: { // La prop debe llamarse 'value' para que funcione con v-model
            type: Date,
            required: true,
        },
        formatLabelDate: {
            type: String,
            default: 'MMM-YYYY'
        },
        disableNewerDates: {
            type: Boolean,
            default: false
        },

    },
    data() {
        return {
            isOpen: false,
            currentYear: 0,
            initialDate: null,
            months: [
                "Enero", "Febrero", "Marzo",
                "Abril", "Mayo", "Junio",
                "Julio", "Agosto", "Septiembre",
                "Octubre", "Noviembre", "Diciembre"
            ],
            selectedDate: null,
        };
    },
    computed: {
        labelDate() {
            // let month = moment(this.selectedDate).format('MMM')
            // month = month.replace('.', '')
            // month = String(month[0]).toUpperCase() + String(month).slice(1)
            // return month + '-' + moment(this.selectedDate).format('YYYY');
            let month = moment(this.selectedDate).format(this.formatLabelDate)
            return month.replace('.', '')
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        handleClickOutside(event) {
            const dropdown = this.$refs.dropdown;
            if (dropdown && !dropdown.contains(event.target)) {
                this.isOpen = false;
            }
        },
        updateYear(added) {
            this.currentYear += added;
        },
        selectMonth(iSelectedMonth) {
            const selectedDate = new Date(this.currentYear, iSelectedMonth, 1)
            this.$emit('input', selectedDate);
            this.isOpen = false;
            this.selectedDate = selectedDate
            this.$emit('onDateChange', selectedDate);
        },
        updateCurrentValue(valueEntered) {
            this.selectedDate = new Date(valueEntered.getFullYear(), valueEntered.getMonth(), 1)
            this.currentYear = this.selectedDate.getFullYear()

        },
        isMonthDisabled(iMonth) {
            const selectedDate = new Date(this.currentYear, iMonth, 1)

            return (this.disableOldDates && selectedDate.getTime() < this.initialDate.getTime() ||
                this.disableNewerDates && selectedDate.getTime() > this.initialDate.getTime())
        },
        isMonthSelected(iMonth) {
            const isYearSelected = this.currentYear == this.selectedDate.getFullYear()
            return isYearSelected && iMonth == this.selectedDate.getMonth()
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        this.updateCurrentValue(this.value)
        this.initialDate = this.disabledFrom

    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },

    watch: {
        value(newValue) {
            this.updateCurrentValue(newValue)
        },
        disabledFrom(newValue) {
            this.updateCurrentValue(newValue)
            this.initialDate = this.selectedDate
        },
    }
};
</script>
<style lang="scss" scoped>
.default_theme {
    --background-color: #002e33;
    --background-hover: #185555;
    --background-click: #3b7a7a;
    --background-click-hover: #3b7a7a;
    --color-border-box-label: #002E33;
    --text-color: white;
    --padding-vert: 12px;
    --padding-horz: 16px;
    --height: 46px;
}

.classification_theme {
    --background-color: white;
    --background-hover: #fcfcfa;
    --background-click: #fffffa;
    --background-click-hover: #f8f8f8;
    --text-color: #475467;
    --padding-vert: 10px;
    --padding-horz: 14px;
    --height: 42px;
    --color-border-box-label: #002E33;
}

.alert_theme {
    --background-color: #FFFAEB;
    --background-hover: #ffedb8;
    --background-click: #dec98b;
    --background-click-hover: #cbb573;
    --color-border-box-label: #FEC84B;
    ;
    --text-color: #4E1D09;
    --padding-vert: 10px;
    --padding-horz: 14px;
    --height: 42px;
}

.custom-select-container {
    position: relative;
}


.custom_label {
    font-size: 0.9rem;
    color: #4a4a4a;
    display: block;
}

.dropdown_label_select {
    background-color: var(--background-color) !important;
    border: 1px solid var(--color-border-box-label);
    border-radius: 8px;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: var(--padding-vert) var(--padding-horz);
    color: var(--text-color);
    user-select: none;

    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    height: var(--height);
    gap: 4px;
}

$select_transition: 0.1s;

.dropdown_label_select:hover {
    background-color: var(--background-hover) !important;
    transition: all $select_transition ease;
}

.dropdown_label_select_clicked {
    background-color: var(--background-click) !important;
}

.dropdown_label_select_clicked:hover {
    background-color: var(--background-click-hover) !important;
    transition: all $select_transition ease;
}

.label_margin {
    margin-bottom: 0.5rem;
}

.actual_button_arrow_down {
    flex-shrink: 0;
    -ms-flex-align: end;
    align-self: center;
    width: 20px;
    height: 20px;
    filter: brightness(0) saturate(100%) invert(15%) sepia(12%) saturate(3180%) hue-rotate(136deg) brightness(97%) contrast(102%)
}

.custom-dropdown {
    position: relative;
    width: 100%;
    // max-width: 300px;
    color: #fff;
}


.selected-label {
    line-height: 1;
}


.dropdown-menu-select {
    position: absolute;
    top: 99%;
    left: 0;
    width: fit-content;
    background-color: #ffffff;
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    display: flex;
    padding: 20px 24px;
    align-items: center;
}

.slide-enter-active,
.slide-leave-active {
    transition: max-height 0.05s ease;
}

.slide-enter {
    max-height: 0px;
}

.slide-leave-to {
    max-height: 0;
}


/* Estilo del contenedor general */
.calendar-container {
    max-width: 400px;
    margin: 0 auto;
    text-align: center;
}

/* Cabecera */
.calendar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    color: #344054
}

/* Botones de la cabecera */
.calendar-header button {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    padding: 5px;
}

.calendar-header button:hover {
    color: #007BFF;
}

/* Matriz de meses */
.calendar-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

/* Estilo de cada celda del mes */
.month-cell {
    padding: 10px 0px;
    width: 88px;
    background-color: #fff;
    border: 1px solid #D0D5DD;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    color: #344054;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
    transition: transform 0.2s ease, background-color 0.2s ease;
}

.month-cell:hover,
.month-cell-activated {
    border: 1px solid #00A9AD;
    background: #EFFEFD;
    transform: translateY(-2px);
}

.rotateLeft {
    transform: rotate(90deg);
}

.rotateRight {
    transform: rotate(270deg);
}
</style>